<template>
    <div>
        <template v-if="item.payment.subject_type === 'App\\Models\\Account'">
            {{ _.get(item, 'payment.subject.name', 'Cont necunoscut') }} (cont)
        </template>
        <template v-else-if="item.payment.subject_type === 'App\\Models\\User'">
            {{ _.get(item, 'payment.subject.name', 'Utilizator necunoscut') }} (utilizator)
        </template>
        <template v-else-if="!_.isNil(item.account_id)">
            {{ _.get(Static.accounts.find(account => account.id === item.account_id), 'name', 'Nedefinit') }} (cont)
        </template>
        <template v-else>
            <b class="text--danger">NECUNOSCUT</b>
        </template>
    </div>
</template>

<script>
export default {
    props: {
        item: {
            type: Object,
            required: true
        }
    }
}
</script>
